/* eslint-disable array-callback-return */
import Card from 'components/UI/Card';
import React from 'react';
import { useSelector } from 'react-redux';
import './index.module.scss';

export default function TopCards() {
    const blocks = useSelector((state) => state.block.entities);

    return (
        <div styleName="topCards">
            {blocks.allIds.map((blockId) => {
                const card = blocks.byId[blockId];
                if (card?.id <= 4)
                    return (
                        <Card
                            key={card.id}
                            title={card?.name}
                            description={card?.content}
                            image={card?.image}
                            popupContent={card?.popup}
                            popupImage={card?.image_popup}
                            page={card?.page}
                            link={card?.link}
                            buttonText={card?.button_text}
                            buttonBackground={card?.colors?.button_background}
                            background={card?.colors?.background}
                            buttonColor={card?.colors?.button_text}
                            row={parseInt(card?.position?.row)}
                            column={parseInt(card?.position?.column)}
                            width={parseInt(card?.position?.width)}
                        />
                    );
            })}
        </div>
    );
}
